import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

export const confirm_delivery = createAsyncThunk(
    'order/confirm_delivery',
    async ({ orderId, sellerOrderId }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/order/delivery-confirm/${orderId}/${sellerOrderId}`)
            return fulfillWithValue({ ...data, sellerOrderId })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_order_escrow_status = createAsyncThunk(
    'order/get_order_escrow_status',
    async (orderId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/order/escrow-status/${orderId}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const place_order = createAsyncThunk(
    'order/place_order',
    async ({ price, products, shippingInfo, userId, navigate, items, taxAmount, paymentMethod = 'full', numInstallments = null }) => {
        try {
            const { data } = await api.post('/home/order/palce-order', {
                price,
                products,
                shippingInfo,
                userId,
                items,
                taxAmount,
                paymentMethod,
                numInstallments,
            });
            navigate('/payment', {
                state: {
                    price: price,
                    items,
                    orderId: data.orderId,
                    paymentMethod,
                    numInstallments
                }
            });
            console.log(data);
            return true;
        } catch (error) {
            console.log(error.response);
        }
    }
);

export const get_orders = createAsyncThunk(
    'order/get_orders',
    async ({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/gat-orders/${customerId}/${status}`);
            return fulfillWithValue(data);
        } catch (error) {
            console.log(error.response);
        }
    }
);

export const get_order = createAsyncThunk(
    'order/get_order',
    async (orderId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/gat-order/${orderId}`);
            return fulfillWithValue(data);
        } catch (error) {
            console.log(error.response);
            return rejectWithValue(error.response.data);
        }
    }
);

export const orderReducer = createSlice({
    name: 'order',
    initialState: {
        myOrders: [],
        sellerOrders: [],
        errorMessage: '',
        successMessage: '',
        myOrder: {},
        escrowStatuses: [],
        confirmingDelivery: {}  // { [sellerOrderId]: true } while in-flight
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = '';
            state.successMessage = '';
        }
    },
    extraReducers: {
        [get_orders.fulfilled]: (state, { payload }) => {
            state.myOrders = payload.orders;
        },
        [get_order.fulfilled]: (state, { payload }) => {
            state.myOrder = payload.order;
            state.sellerOrders = payload.sellerOrders;
        },
        [get_order_escrow_status.fulfilled]: (state, { payload }) => {
            state.escrowStatuses = payload.escrows || [];
        },
        [confirm_delivery.pending]: (state, { meta }) => {
            state.confirmingDelivery[meta.arg.sellerOrderId] = true;
        },
        [confirm_delivery.fulfilled]: (state, { payload }) => {
            delete state.confirmingDelivery[payload.sellerOrderId];
            state.successMessage = payload.message;
            // Mark the escrow as released locally
            state.escrowStatuses = state.escrowStatuses.map(e =>
                e.sellerOrderId === payload.sellerOrderId ? { ...e, status: 'released' } : e
            );
        },
        [confirm_delivery.rejected]: (state, { payload, meta }) => {
            delete state.confirmingDelivery[meta.arg.sellerOrderId];
            state.errorMessage = payload?.error || 'Confirmation failed';
        }
    }
});

export const { messageClear } = orderReducer.actions;
export default orderReducer.reducer;